export { default } from './AnniversaryBanner';
